import { render, staticRenderFns } from "./ClaimNotesTable.vue?vue&type=template&id=71237b55"
import script from "./ClaimNotesTable.vue?vue&type=script&lang=js"
export * from "./ClaimNotesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports